import { AppSettings } from "../settings/AppSettings";

export function maskedStoreCellPhone() {
    if(!AppSettings.StoreCellPhoneNumber || AppSettings.StoreCellPhoneNumber.length !== 11)
        return "";

    return `(${AppSettings.StoreCellPhoneNumber.substring(0, 2)}) ${AppSettings.StoreCellPhoneNumber.substring(2, 7)}-${AppSettings.StoreCellPhoneNumber.substring(7, 11)}`
}